const { getStockReportFields } = require('./tools/prepare-facility-details')

const prepareFacilityImportTemplate = async (mainApi, { serviceId }) => {
  const headers = await getStockReportFields(mainApi, serviceId)

  // Get products for the service
  const productList = await mainApi.product.listForServices([serviceId])

  const templateData = productList.map(product => ({
    productId: product._id,
    productName: product.name
  }))

  return {
    headers,
    data: templateData
  }
}

module.exports = {
  prepareFacilityImportTemplate
}
